/**
 * Modular PDP hero — sticky ATC, gallery sync (buy box logic added in next phase).
 */
(function (doc, win) {
  'use strict';

  var hero = doc.querySelector('[data-pcos-hero]');
  if (!hero) return;
  if (hero.dataset.initialized === 'true') return;
  hero.dataset.initialized = 'true';

  var ctaBtn =
    hero.querySelector('[data-nnh-buy-box-atc]') ||
    hero.querySelector('[data-add-to-cart]');
  var stickyBar = doc.querySelector('.pcos-hero-v2__sticky-bar');
  var stickyBtn = stickyBar ? stickyBar.querySelector('[data-pcos-sticky-cta]') : null;
  var stickyLabel = stickyBar ? stickyBar.querySelector('[data-pcos-sticky-cta-label]') : null;
  var stickyCtaText = stickyLabel ? stickyLabel.querySelector('.sticky-atc-text') : null;
  var stickyCtaPrice = stickyBar ? stickyBar.querySelector('[data-pcos-sticky-cta-price]') : null;
  var stickyCtaPriceMobile = stickyBar ? stickyBar.querySelector('[data-pcos-sticky-cta-price-mobile]') : null;
  var stickySummary = stickyBar ? stickyBar.querySelector('[data-pcos-sticky-summary]') : null;
  var stickyFlavor = stickyBar ? stickyBar.querySelector('[data-pcos-sticky-flavor]') : null;
  var stickyFlavorSwatch = stickyBar ? stickyBar.querySelector('[data-pcos-sticky-flavor-swatch]') : null;
  var stickyFlavorLabel = stickyBar ? stickyBar.querySelector('[data-pcos-sticky-flavor-label]') : null;
  var stickyVariant = stickyBar ? stickyBar.querySelector('[data-pcos-sticky-variant]') : null;
  var stickyPrice = stickyBar ? stickyBar.querySelector('[data-pcos-sticky-price]') : null;
  var stickyTotal = stickyBar ? stickyBar.querySelector('[data-pcos-sticky-total]') : null;
  var buyBox = hero.querySelector('[data-nnh-buy-box]');
  var isFlofitHero = hero.dataset.flofitHero === 'true';
  var variantIdInput = hero.querySelector('[data-variant-id-input]');
  var stickyCtaBaseLabel = hero.dataset.stickyCtaBaseLabel || 'Add To Cart';

  function syncUrlVariant(variantId) {
    if (!variantId) return;
    var vid = String(variantId);
    try {
      var url = new URL(win.location.href);
      url.searchParams.set('variant', vid);
      win.history.replaceState({}, '', url);
    } catch (e) {}

    try {
      if (typeof BoosterTheme !== 'undefined' && BoosterTheme.events) {
        var priceData = doc.getElementById('pdp-price-data');
        var productId = priceData && priceData.dataset && priceData.dataset.productId;
        if (!productId) return;
        BoosterTheme.events.trigger('booster:variant:select', {
          selectedVariant: {
            id: vid,
            available: !(ctaBtn && ctaBtn.disabled),
            isCardSwatches: false,
            price: '$0.00',
            sale: false,
            price_raw: 0,
            sale_raw: false,
            sku: ''
          },
          currentOptions: [],
          product: { id: productId }
        });
      }
    } catch (e) {}
  }

  function updateStickyFlavor() {
    if (!isFlofitHero || !stickyFlavor) return;
    var activeFlavor = doc.querySelector('[data-modular-flavor-option].is-active');
    if (!activeFlavor) {
      stickyFlavor.hidden = true;
      return;
    }
    stickyFlavor.hidden = false;
    var flavorName = activeFlavor.getAttribute('data-flavor') || '';
    var heroSwatch = activeFlavor.querySelector('.modular-pdp-flavor__swatch');
    if (stickyFlavorLabel) stickyFlavorLabel.textContent = flavorName;
    if (stickyFlavorSwatch && heroSwatch) {
      stickyFlavorSwatch.style.backgroundColor = heroSwatch.style.backgroundColor || '';
    }
    if (flavorName) {
      stickyFlavor.setAttribute('aria-label', 'Flavor: ' + flavorName);
    }
  }

  doc.addEventListener('flavorChanged', updateStickyFlavor);

  function readBuyBoxSelection(detail) {
    var state = detail || {};
    if ((!state.label || !state.price) && buyBox) {
      state = {
        label: buyBox.dataset.selectedLabel || state.label || '',
        price: buyBox.dataset.selectedPrice || state.price || '',
        perMonth: buyBox.dataset.selectedPerMonth || state.perMonth || ''
      };
    }
    return state;
  }

  function syncStickyFromBuyBox(detail) {
    if (!stickyBar) return;
    var state = readBuyBoxSelection(detail);
    if (stickyVariant && state.label) {
      var supplyFull = stickyVariant.querySelector('[data-pcos-sticky-supply-full]');
      if (supplyFull) {
        supplyFull.textContent = state.label;
      } else {
        stickyVariant.textContent = state.label;
      }
    }
    if (stickyPrice) {
      stickyPrice.textContent = state.perMonth ? state.perMonth + '/mo' : state.price || '';
    }
    if (stickyTotal) {
      stickyTotal.textContent =
        state.perMonth && state.price ? state.price + ' first order' : state.price || '';
    }
    if (stickyLabel && state.price) {
      if (stickyCtaText && stickyCtaPrice) {
        stickyCtaText.textContent = stickyCtaBaseLabel;
        stickyCtaPrice.textContent = state.price;
        if (stickyCtaPriceMobile) {
          stickyCtaPriceMobile.textContent = state.perMonth ? state.perMonth + '/mo' : state.price;
        }
      } else {
        stickyLabel.textContent = stickyCtaBaseLabel + ' — ' + state.price;
      }
    }
  }

  doc.addEventListener('nnh:buybox:changed', function (e) {
    syncStickyFromBuyBox(e.detail);
  });

  doc.addEventListener('nnh:buybox:ready', function (e) {
    syncStickyFromBuyBox(e.detail);
  });

  function scrollToBuyBox() {
    if (buyBox) {
      var rect = buyBox.getBoundingClientRect();
      var offset = win.pageYOffset + rect.top - 80;
      win.scrollTo({ top: offset, behavior: 'smooth' });
      return;
    }
    var fallback = hero || doc.getElementById('pcos-universal-pdp-buy');
    if (fallback) {
      var fallbackRect = fallback.getBoundingClientRect();
      var fallbackOffset = win.pageYOffset + fallbackRect.top - 80;
      win.scrollTo({ top: fallbackOffset, behavior: 'smooth' });
    }
  }

  if (stickySummary) {
    stickySummary.addEventListener('click', scrollToBuyBox);
    stickySummary.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        scrollToBuyBox();
      }
    });
  }

  function initPcosStickyAddToCart() {
    if (!stickyBar) return;

    var scrollMarker =
      ctaBtn ||
      hero.querySelector('[data-nnh-buy-box-atc]') ||
      hero.querySelector('.pcos-hero-v2__sticky-sentinel') ||
      hero;

    stickyBar.classList.remove('pcos-hero-v2__sticky-bar--visible');

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var buyBoxAtc = hero.querySelector('[data-nnh-buy-box-atc]');
        if (buyBoxAtc && !buyBoxAtc.disabled) buyBoxAtc.click();
        else scrollToBuyBox();
      });
    }

    function checkVisibility() {
      var footer = doc.querySelector('footer, .footer, [role="contentinfo"]');
      var footerInView = false;
      if (footer) {
        var footerRect = footer.getBoundingClientRect();
        footerInView = footerRect.top < win.innerHeight;
      }

      if (footerInView) {
        stickyBar.classList.remove('pcos-hero-v2__sticky-bar--visible');
        stickyBar.setAttribute('aria-hidden', 'true');
        return;
      }

      var isDesktopLike = win.innerWidth > 768;
      if (isDesktopLike) {
        var heroRect = hero.getBoundingClientRect();
        var showDesktopSticky = heroRect.bottom <= 0;
        if (showDesktopSticky) {
          stickyBar.classList.add('pcos-hero-v2__sticky-bar--visible');
          stickyBar.setAttribute('aria-hidden', 'false');
        } else {
          stickyBar.classList.remove('pcos-hero-v2__sticky-bar--visible');
          stickyBar.setAttribute('aria-hidden', 'true');
        }
        return;
      }

      var markerRect = scrollMarker.getBoundingClientRect();
      var scrolledPastCta = markerRect.bottom <= 0;
      if (scrolledPastCta) {
        stickyBar.classList.add('pcos-hero-v2__sticky-bar--visible');
        stickyBar.setAttribute('aria-hidden', 'false');
      } else {
        stickyBar.classList.remove('pcos-hero-v2__sticky-bar--visible');
        stickyBar.setAttribute('aria-hidden', 'true');
      }
    }

    var ticking = false;
    win.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          win.requestAnimationFrame(function () {
            checkVisibility();
            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true }
    );
    win.addEventListener('resize', checkVisibility);
    checkVisibility();
  }

  initPcosStickyAddToCart();

  var reviewsLink = hero.querySelector('.pcos-hero-v2__reviews-link');
  if (reviewsLink) {
    reviewsLink.addEventListener('click', function (e) {
      e.preventDefault();
      var target = doc.getElementById('looxReviews') || doc.getElementById('reviews');
      if (!target) return;
      var header = doc.querySelector('header');
      var headerOffset = header ? header.getBoundingClientRect().height : 0;
      var top = target.getBoundingClientRect().top + win.scrollY - headerOffset - 10;
      win.scrollTo({ top: top, behavior: 'smooth' });
    });
  }

  var testingLink = hero.querySelector('[data-hero-testing-link]');
  if (testingLink) {
    testingLink.addEventListener('click', function (e) {
      var href = testingLink.getAttribute('href') || '';
      if (href.charAt(0) !== '#') return;
      var id = href.slice(1);
      if (!id) return;
      var target = doc.getElementById(id);
      if (!target) return;
      e.preventDefault();
      var header = doc.querySelector('header');
      var headerOffset = header ? header.getBoundingClientRect().height : 0;
      var top = target.getBoundingClientRect().top + win.scrollY - headerOffset - 10;
      win.scrollTo({ top: top, behavior: 'smooth' });
    });
  }

  if (variantIdInput && variantIdInput.value) {
    syncUrlVariant(variantIdInput.value);
  }
  updateStickyFlavor();
  syncStickyFromBuyBox();
  doc.dispatchEvent(new CustomEvent('pdp-hero-gallery:sync-context'));
})(document, window);
